import React, { useState, useCallback } from 'react';
import { deleteLancamentoRecords, deleteAnexosStorage, Lancamento } from '../services/api';

import LancamentoForm from '../components/LancamentoForm';
import LancamentoEditModal from '../components/LancamentoEditModal';
import LancamentosTable from '../components/LancamentosTable';
import {
    Container, Typography, Box, Paper, TextField, InputAdornment
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';

const LancamentosPage: React.FC = () => {
    const [isEditModalOpen, setEditModalOpen] = useState(false);
    const [lancamentoToEdit, setLancamentoToEdit] = useState<Lancamento | null>(null);
    const [refreshTrigger, setRefreshTrigger] = useState(0);
    const [searchTerm, setSearchTerm] = useState('');
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');

    const handleRefresh = useCallback(() => {
        setRefreshTrigger(prev => prev + 1);
        window.location.reload();
    }, []);

    const handleDelete = async (lancamento: Lancamento) => {
        if (window.confirm('Tem certeza que deseja excluir este lançamento e todos os seus itens e anexos?')) {
            try {
                // AVISO: Esta abordagem não é atômica e pode resultar em arquivos órfãos.
                const anexoPaths = lancamento.anexos?.map((anexo: any) => anexo.caminho_arquivo) || [];
                if (anexoPaths.length > 0) {
                    await deleteAnexosStorage(anexoPaths);
                }

                await deleteLancamentoRecords(lancamento.id);

                handleRefresh(); // Refresh list
            } catch (error: any) {
                console.error(error);
                alert(`Erro ao excluir lançamento: ${error.message}`);
            }
        }
    };

    const handleEditClick = (lancamento: Lancamento) => {
        setLancamentoToEdit(lancamento);
        setEditModalOpen(true);
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ my: 4 }}>
                <Typography variant="h4" component="h1" gutterBottom>Lançamentos Financeiros</Typography>
                <Paper sx={{ p: 3, mb: 4 }}>
                    <LancamentoForm onLancamentoAdded={handleRefresh} />
                </Paper>

                <Box sx={{ display: 'flex', gap: 2, mb: 2 }}>
                    <TextField
                        label="Buscar"
                        variant="outlined"
                        size="small"
                        value={searchTerm}
                        onChange={(e) => setSearchTerm(e.target.value)}
                        fullWidth
                        InputProps={{
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchIcon />
                                </InputAdornment>
                            ),
                        }}
                    />
                    <TextField
                        label="Data Início"
                        type="date"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: "9999-12-31" }}
                        value={startDate}
                        onChange={(e) => setStartDate(e.target.value)}
                    />
                    <TextField
                        label="Data Fim"
                        type="date"
                        size="small"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{ max: "9999-12-31" }}
                        value={endDate}
                        onChange={(e) => setEndDate(e.target.value)}
                    />
                </Box>

                <LancamentosTable
                    filters={{
                        search: searchTerm,
                        startDate: startDate,
                        endDate: endDate
                    }}
                    onEdit={handleEditClick}
                    onDelete={handleDelete}
                    refreshTrigger={refreshTrigger}
                />
            </Box>
            <LancamentoEditModal lancamento={lancamentoToEdit} open={isEditModalOpen} onClose={() => setEditModalOpen(false)} onLancamentoUpdated={handleRefresh} />
        </Container>
    );
};

export default LancamentosPage;